export const actionTypes = {
    PURCHASE_ORDER_REQUEST_COMBINED_SHIPPING:
        'PURCHASE_ORDER_REQUEST_COMBINED_SHIPPING',
    PURCHASE_ORDER_LIST: 'PURCHASE_ORDER_LIST',
    PURCHASE_ORDER_PAID_STATUS: 'PURCHASE_ORDER_PAID_STATUS',
    PURCHASE_ORDER_RESET: 'PURCHASE_ORDER_RESET',
    PURCHASE_ORDER_DELETE_SHIPMENT: 'PURCHASE_ORDER_DELETE_SHIPMENT',
    PURCHASE_ORDER_HIDDEN: 'PURCHASE_ORDER_HIDDEN',
    PURCHASE_ORDERS_FEEDBACK_LEFT_BY_BUYER:
        'PURCHASE_ORDERS_FEEDBACK_LEFT_BY_BUYER'
};
